import { NgModule } from '@angular/core';
import { PlayService } from 'src/app/pages/play/play.service';
import { QuestionsService } from 'src/app/pages/play/questions/questions.service';
import { RhythmService } from 'src/app/pages/rhythm/rhythm.service';
import { PromptMessageComponent } from 'src/app/components/prompt-message/prompt-message.component';
import { NavMenuComponent } from 'src/app/components/nav-menu/nav-menu.component';
import { NavMenuStickyComponent } from '../components/nav-menu-sticky/nav-menu-sticky.component';
import { CommonModule } from '@angular/common';
import {DecodeHtmlEntitiesPipe} from 'src/app/pipes/decode-html-entities.pipe'

@NgModule({
	declarations: [
	    PromptMessageComponent,
		NavMenuComponent,
		NavMenuStickyComponent,
		DecodeHtmlEntitiesPipe
	],
	imports: [
		CommonModule
	],
	exports: [
	    PromptMessageComponent,
		NavMenuComponent,
		NavMenuStickyComponent,
		DecodeHtmlEntitiesPipe
	],
	providers: [
		PlayService,
		QuestionsService,
		RhythmService,
	]
})
export class SharedModule { }